import { useContext, useEffect, useState } from 'react'
import ConfigurationApiContext from 'src/provider/API/v2/call-service/configuration'

export const isOnboardingComplete = (checklist: any[]): boolean =>
    Array.isArray(checklist) && checklist.length > 0 &&
    checklist.every((item) => item?.value?.status === 'Completed')

/**
 * Shared across Profile / Branding / Business Logic (and the post-onboarding
 * pages) so every page agrees on the same "is setup done" answer, instead of
 * each page running its own checklist check independently.
 */
export function useConfigurationChecklist() {
    const { getOnboardingChecklist, institutionProfile, getInstitutionProfile } = useContext(ConfigurationApiContext)
    const [loading, setLoading] = useState(true)
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        (async () => {
            if (!institutionProfile) {
                await getInstitutionProfile()
            }
            const checklist = await getOnboardingChecklist()
            setIsComplete(isOnboardingComplete(checklist))
            setLoading(false)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, isComplete, institutionProfile }
}